import { JURISDICTION_LIST } from '@/lib/constants';
import { ActionIcon, Select, Tooltip } from '@mantine/core';
import { ReactNode } from 'react';
import { PiCrosshairSimpleBold, PiGlobeBold } from 'react-icons/pi';

export default function JurisdictionsSelect({
  value,
  onChange,
  disabled = false,
  available = [],
  label = 'Jurisdiction',
  placeholder = 'All jurisdictions',
  leftSection,
  leftSectionPointerEvents,
  strict,
  onStrictChange,
}: {
  value?: string;
  onChange: (value: string | undefined) => void;
  disabled?: boolean;
  available?: string[];
  label?: string;
  placeholder?: string;
  leftSection?: ReactNode;
  leftSectionPointerEvents?: 'all' | 'none' | 'auto';
  strict?: boolean;
  onStrictChange?: (strict: boolean) => void;
}) {
  const strictToggleEnabled = onStrictChange !== undefined;
  const resolvedLeftSection = strictToggleEnabled ? (
    <Tooltip
      label={
        strict
          ? 'Strict: only items matching this jurisdiction'
          : 'Inclusive: also includes jurisdiction-independent items'
      }
      withArrow
    >
      <ActionIcon
        size="xs"
        variant="transparent"
        color={strict ? 'blue' : 'gray'}
        onClick={() => onStrictChange(!strict)}
        disabled={!value}
      >
        {strict ? (
          <PiCrosshairSimpleBold size={14} />
        ) : (
          <PiGlobeBold size={14} />
        )}
      </ActionIcon>
    </Tooltip>
  ) : (
    leftSection
  );
  const resolvedPointerEvents = strictToggleEnabled
    ? 'all'
    : leftSectionPointerEvents;

  return (
    <Select
      size="xs"
      label={label}
      placeholder={placeholder}
      onChange={(value) => onChange(value || undefined)}
      searchable
      clearable
      disabled={disabled}
      value={value}
      leftSection={resolvedLeftSection}
      leftSectionPointerEvents={resolvedPointerEvents}
      data={JURISDICTION_LIST.filter(
        (j) => !available.length || available.includes(j.code),
      ).map(({ code, title }) => ({
        value: code,
        label: title,
      }))}
    />
  );
}
